import { useState, useEffect, useRef } from 'react';
import DocumentEditor from './DocumentEditor';
import WorkerDocuments from './WorkerDocuments';
import './Documents.css';

export default function Documents() {
  const [docs, setDocs]           = useState([]);
  const [editing, setEditing]     = useState(null);
  const [uploading, setUploading] = useState(false);
  const [dragOver, setDragOver]   = useState(false);
  const fileInputRef              = useRef(null);

  const load = async () => {
    try {
      const res  = await fetch('/api/documents', { credentials: 'include' });
      const data = await res.json();
      setDocs(Array.isArray(data) ? data : []);
    } catch { setDocs([]); }
  };

  useEffect(() => { load(); }, []);

  const uploadFile = async (file) => {
    if (!file || file.type !== 'application/pdf') {
      alert('Selecteer een PDF-bestand.');
      return;
    }
    setUploading(true);
    const fd = new FormData();
    fd.append('pdf', file);
    try {
      const res  = await fetch('/api/documents/upload', { method: 'POST', credentials: 'include', body: fd });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error);
      await load();
      setEditing(data);
    } catch (e) { alert(e.message); }
    setUploading(false);
  };

  const handleFileInput = (e) => uploadFile(e.target.files[0]);

  const handleDrop = (e) => {
    e.preventDefault();
    setDragOver(false);
    uploadFile(e.dataTransfer.files[0]);
  };

  const deleteDoc = async (id) => {
    if (!confirm('Dit document definitief verwijderen?')) return;
    await fetch(`/api/documents/${id}`, { method: 'DELETE', credentials: 'include' });
    load();
  };

  const downloadDoc = async (doc) => {
    const res  = await fetch(`/api/documents/${doc.id}/pdf`, { credentials: 'include' });
    const blob = await res.blob();
    const url  = URL.createObjectURL(blob);
    const a    = Object.assign(document.createElement('a'), { href: url, download: doc.filename });
    a.click();
    URL.revokeObjectURL(url);
  };

  const fmtDate = (d) =>
    d ? new Date(d).toLocaleDateString('nl-NL', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—';

  if (editing) {
    return <DocumentEditor doc={{ ...editing }} onBack={() => { setEditing(null); load(); }} />;
  }

  // Het PDF-onderteken-gedeelte is uit beeld gehaald (niet meer gebruikt).
  // De oude documenten staan nog in de database; zie git-geschiedenis om het terug te zetten.
  return (
    <div className="documents-page">
      <div className="documents-header">
        <h2>Documenten</h2>
      </div>
      <WorkerDocuments />
    </div>
  );
}
